import React, { Component, useState, Fragment } from "react";
import { useLocation } from 'react-router-dom';

import { Modal, Button, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import parse from 'html-react-parser';

import settings from '../assets/settings.json';
import Cookies from 'js-cookie'

import {addCmListFunction} from './js/CmListFunction';
import {addPartsFunction} from './js/PartsFunction';

import './css/cm_list_body.css';

export default class CmListBody extends Component{
  state={
		authObj:{},
		mouseClick: false,
		//formData:[],
		tonya_hit:'all',
		list_phase:'取り込み済み',
		list_from:'',
		list_to:'',
		list_jan:'all',
		list_cm_order_no:'all',
		dataArray:[],
		dataArrayFix:[],
		dataFixIdArray:[],
		howmany_order_fix:0,
		tonyaArray:[],
		phaseArray:[],
		hattyuu_status_array:[],
		table_tonya_label:'all',
		table_phase_label:'取り込み済み',
		table_hattyuu_status_label:'all',
		whichRowShow:0,
		showOrderHistory:true,
		isOrderHistoryOpen: false,
		hikiate_howmany:'',
		hattyuu_input_lock:true,
		today_str:'',
		click_tr_no:0,
		click_jan_info:false,
		jan_info_array:[],
		jan_info_jan:'',
		click_jan_next:false,
		jan_next_jan:'',
		jan_next_obj:{},
		item_name_full_index:'',
		comment_full_index:'',
		inputType:'',
		which_api_url:'',
		search_label_text:'',
		show_hattyuu_check:false,
		show_hattyuu_jans_array:[],
		//show_syukka_data_id_arrays:[],
		checkbox_all_boolean:false,
		first_read:true,
		isit_yoyaku_order:false,
		toast_array:[],
		latest_hattyuu_no:'',
		latest_hattyuu_no_index:0,
		history_array:[],
		history_jan:'',
		history_cm_order_no:''
  }

  constructor(props) {
    super(props);

  }



  componentDidMount () {
		let staff_token = Cookies.get('_replace_token');
		let staff_name = Cookies.get('_replace_staff');
		this.setState({authObj:{"token":staff_token, "name":staff_name}})
		this.props.getAuthObj({"token":staff_token, "name":staff_name});

		let todayDate = new Date();
		let today_str = (todayDate.getMonth()+1) + '/' + todayDate.getDate() ;
		this.setState({today_str:today_str});

		let _toObj = new Date(todayDate.setDate(todayDate.getDate() + 1));
    let _to = _toObj.getFullYear() + '-' + (_toObj.getMonth()+1) + '-' + _toObj.getDate() ;
		let _fromObj = new Date(todayDate.setDate(todayDate.getDate() - this.props.data._from));
		let _from = _fromObj.getFullYear() + '-' + (_fromObj.getMonth()+1) + '-' + _fromObj.getDate() ;
		this.props.getFromToObj({"from":_from, "to":_to});

		//let location = useLocation();
		let params = new URLSearchParams(window.location.search);
		let _res = addCmListFunction.checkUrlQuery(params);
		let which_url = _res[0];
		let query = _res[1];
		let add_text = _res[2];
		this.setState({which_api_url:which_url});
		this.setState({search_label_text:add_text});

		let api_url = settings.API_BASE_URL + 'cm_order_list/' +'?token='+staff_token+'&name='+staff_name+'&hit=all&phase=all&JAN=all&cm_order_no=all&hattyuu_no=all&order_key=all&_from='+_from+'&_to='+_to;;
		if(which_url!=='normal'){
			api_url = settings.API_BASE_URL + 'get_cm_search_data/' + query;
		}

    console.log('api_url:'+api_url);
		fetch(api_url)
      .then(res => res.json())
      .then(json =>{
				console.log(json.data.obj);
				this.setState({dataArrayFix:json.data.obj});

				const newArray = [];
				const phaseArray = [];
				const hattyuu_status_array = [];
				const torikomizumiArray = [];
				const dataFixIdArray = [];
				let howmany_torikomi = 0;
				let hattyuu_howmany = 0;
				let prev_jan = '';
				let prev_order_no = '';
				let prev_key = '';
				let prev_hikiate_howmany = 0;
				let prev_hattyuu_zumi = 0;
				let _prev_hikiate_howmany_total = 0;
				let _prev_hattyuu_zumi_total = 0;

				let prev_hattyuu_status_now = '';
				let _amount = 0;
				let _amount_check = false;
				let count = 1;
				let amount_lebel = '';
				for (let i = 0; i < json.data.obj.length; i++) {
					dataFixIdArray.push(json.data.obj[i].id);

					if(json.data.obj[i].when_syukka!==null){
						json.data.obj[i].when_syukka= addCmListFunction.convertDate('syukka-date', json.data.obj[i].when_syukka);
					}

					//console.log(json.data.obj[i].cm_item_name);
					if(json.data.obj[i].cm_item_name.indexOf('予約注文___') !== -1 && this.state.isit_yoyaku_order===false){
						this.setState({isit_yoyaku_order:true});
					}

					//console.log(json.data.obj[i].order_key+' '+String(json.data.obj[i].hattyuu_zumi));

					let this_jan = json.data.obj[i].JAN;
					let this_cm_order_no = json.data.obj[i].cm_order_no;
					let this_amount = json.data.obj[i].amount;

					if(newArray.includes(json.data.obj[i].which_tonya)){

					}else{
						newArray.push(json.data.obj[i].which_tonya);
					}

					if(phaseArray.includes(json.data.obj[i].cm_phase)){

					}else{
						phaseArray.push(json.data.obj[i].cm_phase);
					}

					if(hattyuu_status_array.includes(json.data.obj[i].hattyuu_status_now)){

					}else{
						hattyuu_status_array.push(json.data.obj[i].hattyuu_status_now);
					}

					//if((json.data.obj[i].cm_phase==='取り込み済み' || json.data.obj[i].cm_phase==='住所不備') && json.data.obj[i].hattyuu_status_now==='未発注' ){
					if(json.data.obj[i].hattyuu_status_now==='未発注'){
						//torikomizumiArray.push(json.data.obj[i]);
						//howmany_torikomi ++;
						howmany_torikomi = howmany_torikomi + (json.data.obj[i].amount);
						hattyuu_howmany = hattyuu_howmany + (json.data.obj[i].hattyuu_howmany);
						json.data.obj[i].hattyuu_howmany_fix = json.data.obj[i].hattyuu_howmany;
					}else if(json.data.obj[i].hattyuu_status_now==='発注済'){
						howmany_torikomi = howmany_torikomi + (json.data.obj[i].amount);
						hattyuu_howmany = hattyuu_howmany + (json.data.obj[i].hattyuu_zumi);
						json.data.obj[i].hikiate_howmany = json.data.obj[i].hattyuu_zumi;
					}else if(json.data.obj[i].hattyuu_status_now==='完了'){
						howmany_torikomi = howmany_torikomi + (json.data.obj[i].amount);
						hattyuu_howmany = hattyuu_howmany + (json.data.obj[i].hattyuu_zumi);
						//json.data.obj[i].hikiate_howmany = json.data.obj[i].hattyuu_zumi;
					}

					
					let _which = '0';	
					if(prev_jan===json.data.obj[i].JAN && prev_order_no===json.data.obj[i].cm_order_no && prev_hattyuu_status_now==='完了' && _amount_check===false){	
						_amount = json.data.obj[i].amount_fix - prev_hikiate_howmany;	
						_prev_hikiate_howmany_total = prev_hikiate_howmany;	
						_amount_check=true;
						_which = '1';	
					}else if(prev_jan===json.data.obj[i].JAN && prev_order_no===json.data.obj[i].cm_order_no && prev_hattyuu_status_now==='未発注' && _amount_check===true){	
						//_amount = json.data.obj[i].amount_fix - prev_hikiate_howmany;	
						//_prev_hikiate_howmany_total = prev_hikiate_howmany;	
						_amount_check=true;
						_which = '1-2';	
					}else if(prev_jan===json.data.obj[i].JAN && prev_order_no===json.data.obj[i].cm_order_no && prev_hattyuu_status_now==='完了' && _amount_check===true){	
						_amount = _amount - prev_hikiate_howmany;	
						_prev_hikiate_howmany_total = _prev_hikiate_howmany_total + prev_hikiate_howmany;	
						_which = '2';	
					}else if(prev_jan===json.data.obj[i].JAN && prev_order_no===json.data.obj[i].cm_order_no && prev_hattyuu_status_now==='発注済' && _amount_check===false){	
						_amount = json.data.obj[i].amount_fix - prev_hattyuu_zumi;	
						_prev_hattyuu_zumi_total = prev_hattyuu_zumi;
						_amount_check=true;
						_which = '3';	
					}else if(prev_jan===json.data.obj[i].JAN && prev_order_no===json.data.obj[i].cm_order_no && prev_hattyuu_status_now==='発注済' && _amount_check===true){	
						_amount = _amount - prev_hattyuu_zumi;	
						_prev_hattyuu_zumi_total = _prev_hattyuu_zumi_total + prev_hattyuu_zumi;
						_which = '4';	
					}else{	
						_amount = json.data.obj[i].amount_fix;
						_amount_check = false;
						_prev_hikiate_howmany_total = 0;
						_prev_hattyuu_zumi_total = 0;
						_which = '9';	
					}	

					if(json.data.obj[i].cm_order_no==='10127906'){
						console.log('_which:'+_which+' prev_jan:'+String(prev_jan)+' jan:'+json.data.obj[i].JAN+' prev-order_no:'+String(prev_order_no)+' order_no:'+json.data.obj[i].cm_order_no+' prev_key:'+prev_key+' _amount:'+String(_amount));	
					}

					json.data.obj[i].amount = _amount;


					if(json.data.obj[i].hattyuu_status_now==='未発注' && _amount!==json.data.obj[i].amount_fix && _prev_hattyuu_zumi_total>0){
						json.data.obj[i].prev_hattyuu_zumi = _prev_hattyuu_zumi_total;
						console.log('足された prev_hattyuu_zumi');
						console.dir(json.data.obj[i]);
					}

					if(json.data.obj[i].hattyuu_status_now==='発注済' && _amount!==json.data.obj[i].amount_fix && _prev_hikiate_howmany_total>0){
						json.data.obj[i].prev_hikiate_howmany = _prev_hikiate_howmany_total;
						console.log('足された prev_hattyuu_howmany');
						console.dir(json.data.obj[i]);
					}
					// prev_hattyuu_zumi も prev_hikiate_howmany もたされてない？、どの条件で足される？
					
					
					torikomizumiArray.push(json.data.obj[i]);

					prev_jan = this_jan;
					prev_order_no = this_cm_order_no;
					prev_key = json.data.obj[i].order_key;
					prev_hikiate_howmany = json.data.obj[i].hikiate_howmany;
					prev_hattyuu_zumi = json.data.obj[i].hattyuu_zumi;
					prev_hattyuu_status_now = json.data.obj[i].hattyuu_status_now;

				}

				console.log(hattyuu_howmany);
				console.log(howmany_torikomi);

				//console.log(dataFixIdArray);
				//console.log(json.data.obj);

				this.setState({dataFixIdArray:dataFixIdArray});
				this.props.getDataFixIdArray(dataFixIdArray);
				//newArray.push('');

				this.setState({dataArray:torikomizumiArray});
				this.setState({dataArrayFix:json.data.obj});
				this.props.getCmDatas(json.data.obj);
				this.props.getDataArray(torikomizumiArray);
				this.props.getHowmanyOrderFix(howmany_torikomi);// amountベース

				newArray.sort();
				this.setState({tonyaArray:newArray});
				this.setState({phaseArray:phaseArray});
				this.setState({hattyuu_status_array:hattyuu_status_array});
				

				this.setState({howmany_order_fix:howmany_torikomi});
				this.props.changeSelectTonya(howmany_torikomi); //amountベース

				this.setState({hattyuu_howmany_fix:hattyuu_howmany});
				this.props.changeSelectTonyaHattyuu(hattyuu_howmany, 'all', '');//hattyuu_howmanyベース
				this.props.getHowmanyOrderFixHattyuu(hattyuu_howmany);//hattyuu_howmanyベース

				this.setState({first_read:false});
			});


  }

	openOrderHistoryModal = async (e) => {
		console.dir(e.target.dataset);
		let jan = e.target.dataset.dbJan;
		let cm_order_no = e.target.dataset.dbCmOrderNo;
		let history_array = await addCmListFunction.getHistory(this.state.authObj, jan, cm_order_no)
		this.setState({history_array:history_array});

		this.setState({ isOrderHistoryOpen: true });
		this.setState({history_jan:jan});
		this.setState({history_cm_order_no:cm_order_no});
	}
	closeOrderHistoryModal = () => {
		this.setState({ isOrderHistoryOpen: false });
		this.setState({history_array:[]});
		this.setState({history_jan:''});
		this.setState({history_cm_order_no:''});
	};



	openJanInfo = async (e) => {
		console.dir(e.target.dataset.dbJan);
		this.setState({click_jan_info:true});
		this.setState({jan_info_jan:e.target.dataset.dbJan});
		let res = addCmListFunction.getJanInfo(this.state.authObj, e.target.dataset.dbJan);
		console.dir(res);
		if(res!==undefined){
			this.setState({jan_info_array:res});
		}
	}

	openJanNextInfo = async (e) =>{
		console.dir(e.target.dataset.dbJan);
		this.setState({click_jan_next:true});
		this.setState({jan_next_jan:e.target.dataset.dbJan});
		let res = addCmListFunction.getJanNextInfo(this.state.authObj, e.target.dataset.dbJan);
		console.dir(res);
		if(res!==undefined){
			this.setState({jan_next_obj:res});
		}
	}


	changeItemNameFull = async (e) => {
		console.dir(e.target.dataset.index);
		if(this.state.item_name_full_index===Number(e.target.dataset.index)){
			this.setState({item_name_full_index:''});
		}else{
			this.setState({item_name_full_index:Number(e.target.dataset.index)});
		}
	}

	changeCommentFull = async (e) => {
		console.dir(e.target.dataset.index);
		if(this.state.comment_full_index===Number(e.target.dataset.index)){
			this.setState({comment_full_index:''});
		}else{
			this.setState({comment_full_index:Number(e.target.dataset.index)});
		}
	}

	closeJanInfo = async (e) => {
		this.setState({click_jan_info:false});
	}

	closeJanNextInfo = async (e) => {
		this.setState({click_jan_next:false});
	}

	closeSubmitCheckbox_2 = async (e) => {
		this.setState({show_hattyuu_check:false});
	}


	unlockHattyuuInput = async (e) => {
		if(this.state.hattyuu_input_lock===true){
			this.setState({hattyuu_input_lock:false});
		}else{
			this.setState({hattyuu_input_lock:true});
		}

	}


	pasteHattyuuNo = async (e) => {
		console.dir(e.target);
		//let data_index = document.querySelectorAll('[data-index="0"]');
		//console.dir(data_index[0].value);
		//let first_input = data_index[0].value;
		this.props.pasteHattyuuNo(this.state.latest_hattyuu_no, this.state.latest_hattyuu_no_index-1);
	}

	pasteSyukkaDate = async (e) => {
		console.dir(e.target.parentNode.parentNode.childNodes[0].childNodes[0].value);
		let input_val = e.target.parentNode.parentNode.childNodes[0].childNodes[0].value;
		//let __data = this.state.dataArray;
		//let __data_fix = this.state.dataArrayFix;
		let __data = this.props.data.dataArray;
		let __data_fix = this.props.data.cm_datas;


		let _res_array = addCmListFunction.convertDataSyukkabi('', input_val, __data, __data_fix, this.state.dataFixIdArray, 'all');
		__data = _res_array[0];
		__data_fix = _res_array[1];

		this.setState({dataArray:__data});
		this.setState({dataArrayFix:__data_fix});
		this.props.getCmDatas(__data_fix);
		this.props.getDataArray(__data);

		let re_hattyuu_howmany = addCmListFunction.calcHikiateHowmany(__data);
		if(this.props.data.search_array.length===0){
			this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label, '');//hattyuu_howmanyベース
		}else{
			this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
		}
	}


	goTop = async (e) =>{
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}




  render(){

		var checkboxOnOff = (e) => {
			console.dir(e.target.textContent);
			if(e.target.textContent=='off'){
				this.setState({mouseClick:true})
			}else{
				this.setState({mouseClick:false})
			}
		}

		var checkboxMouseOver = async (e) => {
			//e.preventDefault();
			if(this.state.mouseClick===true){
				console.dir(e.target.id);
				e.target.checked = true;

				//const db_id = e.target.id;
				const db_id = Number(e.target.dataset.checkId);
				//const value = e.target.value;
				//const checked = {key:db_id, val:value};
				if(this.props.data.formData.includes(db_id)){
					let arr = this.props.data.formData;
					arr = arr.filter(function(item) {
							return item !== db_id
					})
					//this.setState({ formData:arr});
					this.props.changeFormData(arr);

				}else{
					const newArray = [...this.props.data.formData];
					newArray.push(db_id);
					//this.setState({ formData:newArray});
					this.props.changeFormData(newArray);
				}

				//console.dir(this.state.formData);
			}

		}

		var checkboxMouseOut = (e) => {

		}

		var resetCheckBoxFunction = async (e) => {
			this.setState({mouseClick:false})
		}


		var checkboxClick = async (e) => {
			console.dir(e.target);
			this.setState({mouseClick:true})
			//const db_id = e.target.id;
			const db_id = Number(e.target.dataset.checkId);
			//const checked = {key:db_id, val:value};

			//if(this.state.formData.includes(db_id)){
			if(this.props.data.formData.includes(db_id)){
				let arr = this.props.data.formData;
				arr = arr.filter(function(item) {
						return item !== db_id
				})
				//this.setState({ formData:arr});
				this.props.changeFormData(arr);

			}else{
				const newArray = [...this.props.data.formData];
				newArray.push(db_id);
				//this.setState({ formData:newArray});
				this.props.changeFormData(newArray);
			}
		}


		var showCutHattyuuBox = async (e) => {
			console.dir(e.target.id);
			if(e.target.id==='show_cut_hattyuu_box_on'){
				this.props.clickShowCutHattyu(true);
			}else{
				this.props.clickShowCutHattyu(false);
			}
			
		}


		var checkboxClickCutHattyuu = async (e) => {
			console.dir(e.target);
			const db_id = Number(e.target.dataset.checkId);
			if(this.props.data.formDataCutHattyuu.includes(db_id)){
				let arr = this.props.data.formDataCutHattyuu;
				arr = arr.filter(function(item) {
						return item !== db_id
				})
				//this.setState({ formData:arr});
				this.props.changeFormDataCutHattyuu(arr);

			}else{
				const newArray = [...this.props.data.formDataCutHattyuu];
				newArray.push(db_id);
				//this.setState({ formData:newArray});
				this.props.changeFormDataCutHattyuu(newArray);
			}
		}



		var checkboxClickAll = async (e) => {
			console.dir(e.target.checked);
			if(e.target.checked===true){
				this.setState({checkbox_all_boolean:true});

				let re_array = [];
				for (let i = 0; i < this.props.data.dataArray.length; i++) {
					var db_id = this.props.data.dataArray[i].id;
					re_array.push(db_id);
				}
				//console.dir(re_array);
				this.props.changeFormData(re_array);

			}else{
				this.setState({checkbox_all_boolean:false});
				this.props.changeFormData([]);
			}

		}



		const handleSubmit = (event) => {
			event.preventDefault();
			console.dir(event)
			console.log(this.props.data.formData);
			// Do something with the form data, like send it to a server
		};



		var handleChangeSelect = async (e) => {
			console.dir(e.target.value);
			this.setState({table_tonya_label: e.target.value});
			this.props.changeSelectTonyaName(e.target.value);
			this.props.changeFormDataCutHattyuu([]);

			{/* cheange event is do in CmList.js */}

			e.preventDefault();
		}



		var handleChangeSelectPhase = async (e) => {
			console.dir(e.target.value);
			this.setState({table_phase_label: e.target.value});
			this.props.changeSelectPhaseName(e.target.value);
			this.props.changeFormDataCutHattyuu([]);
			e.preventDefault();
		}


		var handleChangeSelectHattyuuStatus = async (e) => {
			console.dir(e.target.value);
			this.setState({table_hattyuu_status_label:e.target.value});
			this.props.changeSelectHattyuuStatus(e.target.value);
			this.props.changeFormDataCutHattyuu([]);
			e.preventDefault();
		}

		var submitCheckbox = async (e) => {
			console.log('CLICK 確認('+this.props.data.table_tonya_label+')');
			let todayDate = new Date();
			let today_str = todayDate.getFullYear() + '-' + (todayDate.getMonth()+1).toString().padStart(2, '0') + '-' + todayDate.getDate().toString().padStart(2, '0') ;

			let __data = this.props.data.dataArray;
			let __data_fix = this.props.data.cm_datas;

			//console.dir(this.state.dataFixIdArray);
			//console.dir(this.props.data.formData);
			//console.dir(__data);
			//console.dir(__data_fix);

			
			for (let i = 0; i < this.props.data.formData.length; i++) {
				let this_db_id = Number(this.props.data.formData[i]);
				//console.log(this_db_id);
				let index_at_fix_data = this.state.dataFixIdArray.indexOf(this_db_id);
				//console.log(index_at_fix_data);
				//console.dir( __data_fix[index_at_fix_data]);
				let hikiate_howmany = __data_fix[index_at_fix_data].hikiate_howmany;
				__data_fix[index_at_fix_data].hikiate_howmany = hikiate_howmany;
				//console.log('db_id:'+String(__data_fix[index_at_fix_data].id)+' hikiate_howmany:'+String(hikiate_howmany));
				//__data_fix[index_at_fix_data].when_syukka = today_str;
				for (let ii = 0; ii < __data.length; ii++) {
					if(__data[ii].id===this_db_id){
						__data[ii].hikiate_howmany = hikiate_howmany;
						//__data[ii].when_syukka = today_str;
						break
					}
				}
			}

			//console.dir(__data);
			//console.dir(__data_fix);

			
			//this.props.submitCheckbox('checkbox_submit', __data_fix, __data);

			let re_hattyuu_howmany = 0;
			//re_hattyuu_howmany = addCmListFunction.calcHattyuuHowmany(__data);
			re_hattyuu_howmany = addCmListFunction.calcHikiateHowmany(__data);
			//this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
			if(this.props.data.search_array.length===0){
				this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label, '');//hattyuu_howmanyベース
			}else{
				this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
			}
			this.setState({show_hattyuu_check:true});

			
		}






		var clickTableSubmit = async (e) => {
			console.dir(e.target.previousElementSibling.value);
			let whichSubmitSelect = e.target.previousElementSibling.value;
			if(whichSubmitSelect==='submit_select_reorder'){
				let resArray = await addCmListFunction.reorder(this.state.authObj, this.props.data.formData)
				console.log(resArray);

				let reArray_1 = []
				let reArray_fix = []
				for (let i = 0; i < this.state.dataArray.length; i++) {
					for (let ii = 0; ii < resArray.length; ii++) {
						if(this.state.dataArray[i].id===resArray[ii].id){
							reArray_1.push(resArray[ii]);
						}else{
							reArray_1.push(this.state.dataArray[i]);
						}
					}
				}

				for (let i = 0; i < this.state.dataArrayFix.length; i++) {
					for (let ii = 0; ii < resArray.length; ii++) {
						if(this.state.dataArrayFix[i].id===resArray[ii].id){
							reArray_fix.push(resArray[ii]);
						}else{
							reArray_fix.push(this.state.dataArrayFix[i]);
						}
					}
				}

				this.setState({dataArray:reArray_1});
				this.setState({dataArrayFix:reArray_fix});
			}
		}


		var trClick = (e) => {
			console.dir(e.target);
			let this_row_class = e.target.parentElement.parentElement.className; // table-row  hidden_45
			let text_index = this_row_class.search('hidden_');
			let row_index_id = Number(this_row_class.substring(text_index+7));
			console.log(row_index_id);// cm_orderのID
			if(row_index_id!==this.state.whichRowShow){
				this.setState({whichRowShow:row_index_id});
			}else{
				this.setState({whichRowShow:0});
			}
			e.preventDefault();
		}


		var trIndexClick = (e) => {
			console.dir(e.target);
			//console.log(e.target.parentNode.dataset.rowId);
			if(e.target.name!=='from' && e.target.name!=='hikiate_howmany' && e.target.name!=='index_checkbox' && e.target.dataset.dbJan===undefined && e.target.dataset.icon!=='tonya-item-link'){
				this.setState({click_tr_no:Number(e.target.parentNode.dataset.rowId)});
				e.preventDefault();
			}

		}



		var handleInputChange = async (e) => {
			console.dir(e.target);
			if(e.target.value===NaN || e.target.value==="NaN"){
				e.target.value = 0;
			}

			//let __data = this.state.dataArray;
			//let __data_fix = this.state.dataArrayFix;
			let __data = this.props.data.dataArray;
			let __data_fix = this.props.data.cm_datas;
			let re_hattyuu_howmany = 0;
			let this_db_id = 0;
			let index_at_fix_data = 0;


			if(e.target.name!=='hikiate_howmany_2' && e.target.name!=='from_2'){
				this_db_id = Number(e.target.dataset.inputId);
				console.log('this_db_id:'+String(this_db_id));
				console.log('e.target.dataset.index '+String(e.target.dataset.index))
				index_at_fix_data = this.state.dataFixIdArray.indexOf(this_db_id);
				console.log('index_at_fix_data '+String(index_at_fix_data));
			}



			if(e.target.name==='hikiate_howmany_2'){
				let _jan = e.target.dataset.jan;
				let input_val = Number(e.target.value);
				console.log('hikiate_howmany_2 '+_jan + ' ' + input_val);

				let _res_array = [];
				let now_select_tonya_id = addCmListFunction.convertTonyaNameToId(this.props.data);
				let write_key_tonya_id_array = settings.NO_COUNT_SAME_JAN_TONYA_IDs;
				if (write_key_tonya_id_array.includes(now_select_tonya_id)) {
					this_db_id = Number(e.target.dataset.inputId);
					_res_array = addCmListFunction.convertDataHikiateId(this_db_id, input_val, __data, __data_fix, this.state.dataFixIdArray);
				}else{
					_res_array = addCmListFunction.convertDataHikiate(_jan, input_val, __data, __data_fix, this.state.dataFixIdArray, 'change');
				}

				__data = _res_array[0];
				__data_fix = _res_array[1];

				this.setState({dataArray:__data});
				this.setState({dataArrayFix:__data_fix});
				this.props.getCmDatas(__data_fix);
				this.props.getDataArray(__data);

				re_hattyuu_howmany = addCmListFunction.calcHikiateHowmany(__data);
				if(this.props.data.search_array.length===0){
					this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label, '');//hattyuu_howmanyベース
				}else{
					this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
				}


			}else if(e.target.name==='from_2'){
				console.log(e.target.value);
				let _jan = e.target.dataset.jan;
				let input_val = e.target.value;
				console.log('from_2 '+_jan + ' ' + input_val);

				let _res_array = [];
				let now_select_tonya_id = addCmListFunction.convertTonyaNameToId(this.props.data);
				let write_key_tonya_id_array = settings.NO_COUNT_SAME_JAN_TONYA_IDs;
				if (write_key_tonya_id_array.includes(now_select_tonya_id)) {
					this_db_id = Number(e.target.dataset.inputId);
					_res_array = addCmListFunction.convertDataSyukkabiId(this_db_id, input_val, __data, __data_fix, this.state.dataFixIdArray);
				}else{
					_res_array = addCmListFunction.convertDataSyukkabi(_jan, input_val, __data, __data_fix, this.state.dataFixIdArray, 'change');
				}

				__data = _res_array[0];
				__data_fix = _res_array[1];

				this.setState({dataArray:__data});
				this.setState({dataArrayFix:__data_fix});
				this.props.getCmDatas(__data_fix);
				this.props.getDataArray(__data);

				re_hattyuu_howmany = addCmListFunction.calcHikiateHowmany(__data);
				if(this.props.data.search_array.length===0){
					this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label, '');//hattyuu_howmanyベース
				}else{
					this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
				}


			}else if(e.target.name==='hattyuu_no'){
				let _hattyuu_no = e.target.value.replace(/ /g,'');
				__data[Number(e.target.dataset.index)].hattyuu_no = _hattyuu_no;
				__data_fix[index_at_fix_data].hattyuu_no = _hattyuu_no;



				//複数注文時 各行に入力
				let amount = __data[Number(e.target.dataset.index)].amount;

				this.setState({dataArray:__data});
				this.setState({dataArrayFix:__data_fix});
				this.props.getCmDatas(__data_fix);
				this.props.getDataArray(__data);

				re_hattyuu_howmany = addCmListFunction.calcHattyuuHowmany(__data);
				this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label, '');//hattyuu_howmanyベース

				this.setState({latest_hattyuu_no:_hattyuu_no});
				this.setState({latest_hattyuu_no_index:Number(e.target.dataset.index)+1})

			}else if(e.target.name==='hattyuu_howmany'){
				console.log('hattyuu_howmany');
				__data[Number(e.target.dataset.index)].hattyuu_howmany = Number(e.target.value);
				__data_fix[index_at_fix_data].hattyuu_howmany = Number(e.target.value);
				//console.dir(__data[Number(e.target.dataset.index)]);

				this.setState({dataArray:__data});
				this.setState({dataArrayFix:__data_fix});
				this.props.getCmDatas(__data_fix);
				this.props.getDataArray(__data);

				re_hattyuu_howmany = addCmListFunction.calcHattyuuHowmany(__data);
				this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label, '');//hattyuu_howmanyベース

				if(__data_fix[index_at_fix_data].hattyuu_howmany_fix< Number(e.target.value)){
					let re_array = [];
					for (let i = 0; i < this.state.toast_array.length; i++) {
						if(this.state.toast_array[i].id!==__data_fix[index_at_fix_data].id){
							re_array.push(this.state.toast_array[i]);
						}
					}

					let re_toast_array = addCmListFunction.getOverNumberInputText(__data_fix[index_at_fix_data], __data_fix, Number(e.target.value), this.state.toast_array, '-', re_array);
					//console.dir(re_toast_array);
					this.setState({toast_array:re_toast_array});
				}else if(__data_fix[index_at_fix_data].hattyuu_howmany_fix> Number(e.target.value)){
					let re_array = [];
					for (let i = 0; i < this.state.toast_array.length; i++) {
						if(this.state.toast_array[i].id!==__data_fix[index_at_fix_data].id){
							re_array.push(this.state.toast_array[i]);
						}
					}
					//console.dir(re_array);
					let re_toast_array = addCmListFunction.getOverNumberInputText(__data_fix[index_at_fix_data], __data_fix, Number(e.target.value), this.state.toast_array, '+', re_array);
					//console.dir(re_toast_array);
					this.setState({toast_array:re_toast_array});
				}else{
					let re_array = [];
					for (let i = 0; i < this.state.toast_array.length; i++) {
						if(this.state.toast_array[i].id!==__data_fix[index_at_fix_data].id){
							re_array.push(this.state.toast_array[i]);
						}
					}
					this.setState({toast_array:re_array});
				}



			}else if(e.target.name==='hikiate_howmany'){
				console.log('hattyuu_zumi(FIX):'+String(__data_fix[index_at_fix_data].hattyuu_zumi));
				//console.log('hattyuu_zumi:'+String(__data[Number(e.target.dataset.index)].hattyuu_zumi));
				//console.log('hattyuu_howmany(FIX):'+String(__data_fix[index_at_fix_data].hattyuu_howmany));
				//console.log('hattyuu_howmany:'+String(__data[Number(e.target.dataset.index)].hattyuu_howmany));
				//console.log('hikiate_howmany 入力値:'+String(Number(e.target.value)));
				this.setState({inputType:'hikiate_howmany'});

				let todayDate = new Date();
				let today_str = todayDate.getFullYear() + '-' + (todayDate.getMonth()+1).toString().padStart(2, '0') + '-' + todayDate.getDate().toString().padStart(2, '0') ;

				if(__data_fix[index_at_fix_data].hattyuu_zumi!==Number(e.target.value)){
				//if(__data[Number(e.target.dataset.index)].hattyuu_zumi!==Number(e.target.value)){
					console.log('HIKIATE DIFF');
					let diff = __data_fix[index_at_fix_data].hattyuu_zumi-Number(e.target.value);
					//let diff = __data[Number(e.target.dataset.index)].hattyuu_zumi-Number(e.target.value);
					console.log('diff '+String(diff));
					////__data_fix[index_at_fix_data].hattyuu_zumi = Number(e.target.value);
					////__data[Number(e.target.dataset.index)].hattyuu_zumi = Number(e.target.value);
					__data_fix[index_at_fix_data].hikiate_howmany = Number(e.target.value);
					__data[Number(e.target.dataset.index)].hikiate_howmany = Number(e.target.value);
					//this.props.data.cm_datas.hattyuu_howmany = diff;
					//this.props.data.dataArray.hattyuu_howmany = diff;
					//this.props.data.cm_datas.hikiate_howmany = Number(e.target.value);
					//this.props.data.dataArray.hikiate_howmany = Number(e.target.value);
					//__data_fix[index_at_fix_data].when_syukka = today_str;
					//__data[Number(e.target.dataset.index)].when_syukka = today_str;

				}else{
					console.log('HIKIATE SAME');
					__data_fix[index_at_fix_data].hikiate_howmany = Number(e.target.value);
					__data[Number(e.target.dataset.index)].hikiate_howmany = Number(e.target.value);

					//today_str = '2023-05-29';
					//let target_elem = document.getElementById('tonya_syukka_date_'+String(this_db_id));
					//__data_fix[index_at_fix_data].when_syukka = today_str;
					//__data[Number(e.target.dataset.index)].when_syukka = today_str;
				}

				//console.dir(__data_fix[index_at_fix_data]);
				//console.dir(__data[Number(e.target.dataset.index)]);
				//console.dir(__data);

				this.setState({dataArray:__data});
				this.setState({dataArrayFix:__data_fix});
				this.props.getCmDatas(__data_fix);
				this.props.getDataArray(__data);

				re_hattyuu_howmany = addCmListFunction.calcHikiateHowmany(__data);
				//this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
				if(this.props.data.search_array.length===0){
					this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label, '');//hattyuu_howmanyベース
				}else{
					this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
				}

			}else if(e.target.name==='from'){

				__data_fix[index_at_fix_data].when_syukka = e.target.value;
				__data[Number(e.target.dataset.index)].when_syukka = e.target.value;
				this.setState({dataArray:__data});
				this.setState({dataArrayFix:__data_fix});
				this.props.getCmDatas(__data_fix);
				this.props.getDataArray(__data);

				re_hattyuu_howmany = addCmListFunction.calcHikiateHowmany(__data);
				if(this.props.data.search_array.length===0){
					this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label, '');//hattyuu_howmanyベース
				}else{
					this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
				}


				//this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label, '');//hattyuu_howmanyベース
			}

			e.preventDefault();
		}




		const handleSubmitHikiateOkButton = async (e) => {
			console.log('CLICK handleSubmitHikiateOkButton');
			e.preventDefault();
			//console.dir(e.target);
			//console.dir(this.props.data.formData);

			//let _concat_id_array = this.state.show_syukka_data_id_arrays.concat(this.props.data.formData);	
			//this.setState({show_syukka_data_id_arrays:_concat_id_array});	
			let _concat_id_array = this.props.data.show_syukka_data_id_arrays.concat(this.props.data.formData);	
			this.props.getShowSyukkaDataIdArrays(_concat_id_array);

			//let __data = this.state.dataArray;
			//let __data_fix = this.state.dataArrayFix;
			let __data = this.props.data.dataArray;
			let __data_fix = this.props.data.cm_datas;

			let _val = 0;
			let elem_val = 0;
			let _hattyuu_zumi = 0;
			let hikiate_zero_id_array = '';

			for (let i = 0; i < e.target.length; i++) {
				let _jan = e.target[i].dataset['jan'];
				let this_db_id = Number(e.target[i].dataset.inputId);
        elem_val = Number(e.target[i].value);
        if(elem_val===undefined || elem_val===''){
          elem_val = 0;
        }
				console.log(_jan+' '+elem_val);
				if(_jan===undefined){
					console.log('break 973');
					break;
				}

				if(e.target[i].name==='from_2'){
					continue
				}

				//console.log('check976: '+_jan+' '+this_db_id+' '+elem_val);
				//console.dir(e.target[i]);

				let _res_array = [];
				let now_select_tonya_id = addCmListFunction.convertTonyaNameToId(this.props.data);
				let write_key_tonya_id_array = settings.NO_COUNT_SAME_JAN_TONYA_IDs;
				if (write_key_tonya_id_array.includes(now_select_tonya_id)) {
					_res_array = addCmListFunction.convertDataHikiateId(this_db_id, elem_val, __data, __data_fix, this.state.dataFixIdArray);
				}else{
					_res_array = addCmListFunction.convertDataHikiate(_jan, elem_val, __data, __data_fix, this.state.dataFixIdArray, 'submit');
				}
				//let _res_array = addCmListFunction.convertDataHikiate(_jan, elem_val, __data, __data_fix, this.state.dataFixIdArray, 'submit');
				
				__data = _res_array[0];
				__data_fix = _res_array[1];

        if(hikiate_zero_id_array===''){
          hikiate_zero_id_array =  _res_array[3];
        }else{
          hikiate_zero_id_array = hikiate_zero_id_array.concat(_res_array[3]);
        }
			}

			let yoyaku_keppins = addPartsFunction.checkYoyakuKeppin(hikiate_zero_id_array, __data, __data_fix, this.props.data.dataFixIdArray); //
      __data = yoyaku_keppins[0];
      __data_fix = yoyaku_keppins[1];

			//console.dir(hikiate_zero_id_array);
			//console.dir(__data);

			this.setState({dataArray:__data});
			this.setState({dataArrayFix:__data_fix});
			this.props.getCmDatas(__data_fix);
			this.props.getDataArray(__data);

			let re_hattyuu_howmany = 0;
			re_hattyuu_howmany = addCmListFunction.calcHikiateHowmany(__data);
			//this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
			if(this.props.data.search_array.length===0){
				this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label, '');//hattyuu_howmanyベース
			}else{
				this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
			}

			this.setState({show_hattyuu_check:false});
		}



		var closeToastChild = async (e) => {
			//console.dir(e.target);
			let db_id = Number(e.target.id.replace('toast_',''));
			let re_array = [];
			for (let i = 0; i < this.state.toast_array.length; i++) {
				if(this.state.toast_array[i].id!==db_id){
					re_array.push(this.state.toast_array[i]);
				}
			}
			this.setState({toast_array:re_array})
		}







		//console.dir(this.state.formData);
		//console.dir(this.props.data.dataArray.length);
		//console.log(this.state.hattyuu_input_lock);
		//console.dir(this.props.data.dataArray);

		let map_array = [];
		//if(this.props.data.dataArray.length===0 && this.props.data.table_tonya_label==='all' && this.state.first_read===true){
		////if(this.props.data.dataArray.length===0){
		//	map_array = this.state.dataArray;
		//	this.setState({first_read:true});
		//}else{
		//	map_array = this.props.data.dataArray;
		//}
		map_array = this.props.data.dataArray;




		let _loop_length = map_array.length;

		let diff_total = 0;
		let row_amount_total = 0;
		let hattyuu_val_total = 0;
		let prev_hattyuu_zumi_total = 0;
		let prev_hikiate_howmany_total = 0;
		let prev_hattyuu_howmany_total = 0;
		let diff_counter = 0;
		let diff_counter_label = '';

		let count = 0;
		let prev_tonya_name_f = ';'
		let checkbox_boolean = false;
		let checkbox_boolean_cut_hattyuu = false;
		let isit_show_hikiate_howmany = false;
		let isit_checkbox_show = false;
		let isit_checkbox_show_cut_hattyuu = false;

		let hattyuu_jan_array = [];
		let for_mihattyuu_hattyuuzumi_label = '';
		

		//console.dir(this.props.data.dataArray);
		//console.dir(map_array);
		//console.dir(this.props.data.formData);
		//console.dir(this.state.toast_array);
		//console.log(this.props.data.table_tonya_label);
		//console.log(this.props.data.isit_hattyuu_board);
		////console.dir(this.state.show_syukka_data_id_arrays);
		//console.dir(this.props.data.cm_datas);
		//console.dir(this.props.data.hikiate_zero_id_array);

    return (
      <main className={this.state.isOrderHistoryOpen ? 'overflow_hidden' : ''} id="main-table">
    		{/* <Form onSubmit={handleSubmit}> */}
    		{/*  {checkboxContent} */}
				


				<table className="cm-table-main small mb-7">
					<thead>
						<tr className="table-row header sticky-top">
							<td className="table-col nowrap">
								No.
								{ this.props.data.search_label ? (<div className="search-label" >検索結果表示中: {this.props.data.search_text}</div>) : (<></>)}
								{ this.state.which_api_url!=='normal' && this.props.data.search_label===false ? <div className="search-label" >検索結果表示中: {this.state.search_label_text}</div> :<></> }
								{this.props.data.isit_hattyuu_board===true && this.props.data.table_tonya_label!=='all' && this.props.data.formData!==undefined ? <>
									<Form.Check
										className="index-checkbox"
										onClick={event=>checkboxClickAll(event)}
										checked={this.state.checkbox_all_boolean}
										name = 'index_checkbox_all'
									/>
								</> : <></>}

								{this.props.data.isit_hattyuu_board===false ? 
									<>
										{this.props.data.show_cut_hattyuu_box===false ? 
											<>
												<span className="cut-hattyuu-onoff-label click-pointer-elem" id="show_cut_hattyuu_box_on" onClick={event=>showCutHattyuuBox(event)}>発注除外OFF中</span>
											</> : 
											<>
												<span className="cut-hattyuu-onoff-label" id="show_cut_hattyuu_box_off" onClick={event=>showCutHattyuuBox(event)} >発注除外ON!中</span>
											</>
										}
									</>:<></>
								}

							</td>

							<td className="table-col nowrap"> {/* 状況 */}
								<select className="custom-select text-center" value={this.props.data.table_hattyuu_status_label} onChange={handleChangeSelectHattyuuStatus}>
									{this.state.hattyuu_status_array.map((status, index)=>{
          	  			return(
											<option key={index} value={status}>{status}</option>

										)
									})}

									{this.state.isit_yoyaku_order ? <><option value="yoyaku">予約注文済</option></> : <></>}

									<option defaultValue="すべて" value="all">すべて</option>
          			</select>
							</td>

							<td className="table-col nowrap">CM管理番号</td>
							<td className="table-col nowrap">明細行</td>
							<td className="table-col nowrap">KEY</td>
							<td className="table-col nowrap">受注数</td>
							<td className="table-col nowrap">JAN</td>
							<td className="table-col nowrap">型番</td>

							<td className="table-col nowrap lock-icon-parent">
								発注No.
								<div className={this.props.data.clickPasteHattyuuNo===false ? "lock-icon-child hattyuu_no_paste click-pointer-elem" : "lock-icon-child hattyuu_no_paste click-pointer-elem text-dark"} onClick={this.pasteHattyuuNo}><i className="bi bi-arrow-bar-down"></i></div>
							</td>


							<td className="table-col nowrap">発注日</td>

							<td className="table-col nowrap lock-icon-parent">
								発注した数
								<div className="lock-icon-child click-pointer-elem" onClick={this.unlockHattyuuInput}>
									{this.state.hattyuu_input_lock ? <img src={"./images/lock-fill.svg"} /> : <img src="images/unlock-fill.svg" /> }
								</div>
							</td>

							<td className="table-col nowrap">受注数-発注数</td>

							<td className="table-col nowrap ">
								引当たり数
								{/* <span><i className="bi bi-question-circle hint-icon"></i></span> */}
							</td>
							<td className="table-col nowrap ">
								発注-引当
								{/* <span><i className="bi bi-question-circle hint-icon"></i></span> */}
							</td>
							<td className="table-col nowrap ">
								問屋出荷日
								{/* <span><i className="bi bi-question-circle hint-icon"></i></span> */}
							</td>

							<td className="table-col">
								<select className="custom-select text-center" value={this.props.data.table_phase_label} onChange={handleChangeSelectPhase}>
									{this.state.phaseArray.map((phase, index)=>{
          	  			return(
											<option key={index} value={phase}>{phase}</option>
										)
									})}
									<option defaultValue="すべて" value="all">すべて</option>
          			</select>
							</td>

							<td className="table-col"> {/* tonya select */}
								<select id="tonya-table-select-label" className="custom-select text-center" value={this.props.data.table_tonya_label} onChange={handleChangeSelect}>
									{this.state.tonyaArray.map((tonya, index)=>{
          	  			return(
											<option key={index} value={tonya}>{tonya}</option>
										)
									})}
									<option defaultValue="すべて" value="all">すべて</option>

          			</select>
							</td>

							<td className="table-col nowrap">数量</td>
							<td className="table-col">CM商品名</td>
							<td className="table-col nowrap">色番</td>
							<td className="table-col nowrap">サイズ番</td>
							<td className="table-col nowrap">受注単価</td>
							<td className="table-col nowrap">問屋単価</td>
							{/* <td className="table-col">TIME_LIMIT</td> */}
							<td className="table-col nowrap">間に合う？</td>
							<td className="table-col nowrap">愛知発送予定</td>
							<td className="table-col">発送期限</td>
							<td className="table-col">注文日時</td>
							<td className="table-col">店舗</td>
							<td className="table-col">注文番号</td>
							<td className="table-col">商品コード</td>
							<td className="table-col">送り先名</td>
							<td className="table-col nowrap">送り先〒</td>
							<td className="table-col nowrap">送り先</td>
							<td className="table-col nowrap">CMコメント</td>
							<td className="table-col nowrap">受注時の問屋在庫残</td>
							<td className="table-col nowrap">データ取込日時</td>
						</tr>

					</thead>

					<tbody>
						{map_array.length===0 ? 'non' :
          	map_array.map((row, index)=>{
							// DEV
							//if(row.cm_order_no!=='10109102'){
							//	return null;
							//}

							let multi_row = false;
							let row_amount = '';
							let multi_row_style = '';
							let this_jan = row.JAN;
							let this_order_no = row.cm_order_no;
							let amount_index = 0;
							let class_index = '';
							let be_order_count = 0;
							isit_show_hikiate_howmany = false;

							let hikiate_input_class = '';

							let previousCmOrderNoValue = index > 0 ? map_array[index - 1].cm_order_no : null;
							let previousJanValue = index > 0 ? map_array[index - 1].JAN : null;
							let previousKey = index > 0 ? map_array[index - 1].order_key : null;
							let previousStatus = index > 0 ? map_array[index - 1].hattyuu_status_now : null;
							let nextCmOrderNoValue = null;
							let nextJanValue = null
							try{
								nextCmOrderNoValue = index > 0 ? map_array[index + 1].cm_order_no : null;
								nextJanValue = index > 0 ? map_array[index + 1].JAN : null;
							}catch(error){

							}


							let prev_hattyuu_howmany = index > 0 ? map_array[index - 1].hattyuu_howmany : null;


							//if(row.amount===0 && this.props.data.table_tonya_label==='all'){
							//	row_amount = '';
							//}else{
							//	//row_amount = row.amount_fix;
							//	row_amount = row.amount;
							//}
							if(row.order_key.indexOf('-') !== -1){
								row_amount = row.amount;
							}else{
								row_amount = row.amount_fix;
							}


							let prev_hattyuu_zumi='';
							if(row.prev_hattyuu_zumi!==undefined){
								prev_hattyuu_zumi = row.prev_hattyuu_zumi;
								prev_hattyuu_zumi_total = prev_hattyuu_zumi_total + prev_hattyuu_zumi;
							}

							let prev_hikiate_howmany='';
							if(row.prev_hikiate_howmany!==undefined){
								prev_hikiate_howmany = row.prev_hikiate_howmany;
								prev_hikiate_howmany_total = prev_hikiate_howmany_total + prev_hikiate_howmany;
							}

							////if(row_amount!=='' && ( previousCmOrderNoValue!==row.cm_order_no && previousJanValue!==row.JAN)){
							////if(row_amount!=='' && (previousJanValue!==row.JAN)){
							//if(row_amount!=='' && ( previousCmOrderNoValue!==row.cm_order_no || previousJanValue!==row.JAN)){
							//	row_amount_total = row_amount_total + row.amount_fix;
							//}else{
							//	//console.log(row.cm_order_no);
							//	//console.log(previousCmOrderNoValue);
							//	//console.log(previousJanValue);
							//	//console.log(row.JAN);
							//}

							if(this.props.data.which_soart===7){
								diff_counter_label = '未発注以外';
							}

							count++;
							prev_tonya_name_f=row.which_tonya;

							//console.dir(this.state.dataArray[index]);
							if(map_array[index]===undefined){
								return;
							}

							let sankaku_mark = ''

							let tonya_price = '';
							if(row.tonya_price===999999){
								tonya_price = '-';
							}else{
								tonya_price = row.tonya_price;
							}

							let hattyuu_input_calss_str = ''; // 発注した数
							let hattyuu_no_input_class = ''; // 発注No.
							let input_width = 0;
							let input_style_obj = {};
							if(index===0){
								try{
									input_width = (map_array[index].hattyuu_no.length + 1)*12;
									input_style_obj = {width:String(input_width)+"px"}
								}catch (error) {

								}

							}

							if(row.hattyuu_status_now!=='未発注' && row.which_tonya!=='欠品'){
								hattyuu_input_calss_str = 'form-control form-control-sm border border-dark bg-input-lock text-center input-hattyuu-zumi-lock';
							}else if(this.state.hattyuu_input_lock===true){
								hattyuu_input_calss_str = 'form-control form-control-sm border border-dark bg-input-lock text-center';
							}else{
								hattyuu_input_calss_str = 'form-control form-control-sm border border-primary text-center';
							}

							let keppin = false;
							if(row.which_tonya==='欠品'){
								keppin=true;
							}

							if(row.hattyuu_status_now!=='未発注'){
								hattyuu_no_input_class = 'form-control form-control-sm border border-dark bg-input-lock text-center input-hattyuu-zumi-lock text-center width-auto';
							}else{
								hattyuu_no_input_class = 'form-control form-control-sm input-w-m border border-primary text-center width-auto';
							}

							let hattyuu_date = '';
							if(row.hattyuu_date!==null){
								hattyuu_date = addCmListFunction.convertDate('day', row.hattyuu_date);
							}else{
								hattyuu_date = '';
							}


							if(row.cm_item_name===undefined){
								//return;
								row.cm_item_name = '';
							}



							let tr_class_name = 'table-row ';
							if(this.props.data.hikiate_zero_id_array===undefined){
								this.props.data.hikiate_zero_id_array = [];
							}
							if(this.props.data.hikiate_zero_id_array.includes(row.id)){
								tr_class_name = 'table-row tr-height-excel-warning';
							}else if(this.props.data.hikiatari_id_array_fix.includes(row.id)){
								tr_class_name = 'table-row tr-height-excel';
							}
							if(row.id===this.state.click_tr_no){
								tr_class_name = 'table-row tr-height';
							}



							let hattyuu_val = 0;
							if(row.hattyuu_status_now==='未発注'){
								hattyuu_val = map_array[index].hattyuu_howmany;
							}else if(row.hattyuu_status_now==='発注済'){
								hattyuu_val = map_array[index].hattyuu_zumi;
							}else if(row.hattyuu_status_now==='完了'){
								//hattyuu_val = map_array[index].hikiate_howmany;
								hattyuu_val = map_array[index].hattyuu_zumi;
								isit_show_hikiate_howmany = true;
							}
							hattyuu_val_total = hattyuu_val_total + hattyuu_val;


							let _hattyuu_val = 0;
							let _isit_multi_row = false;
							let amount_diff = 0;
							for_mihattyuu_hattyuuzumi_label = '';

							//if(row_amount!=='' && ( previousCmOrderNoValue!==row.cm_order_no && previousJanValue!==row.JAN)){
							//if(row_amount!=='' && (previousJanValue!==row.JAN)){
							
							var _which = 0;
							if(row_amount!=='' && ( previousCmOrderNoValue!==row.cm_order_no || previousJanValue!==row.JAN || previousKey!==row.order_key)  && this.props.data.table_tonya_label!=='欠品'){
								if(previousCmOrderNoValue!==row.cm_order_no || previousJanValue!==row.JAN ){
									row_amount_total = row_amount_total + row.amount_fix;

									if(row.hattyuu_status_now==='未発注' && row.amount_fix!==row.amount){
										for_mihattyuu_hattyuuzumi_label = '(完数:'+String(row.amount_fix-row.amount)+')'; // 0717変えた
									}
									
								}
								
								if(keppin===true && this.props.data.table_tonya_label!=='欠品' && this.props.data.table_tonya_label!=='all'){
									amount_diff = row_amount-prev_hattyuu_howmany;
									prev_hattyuu_howmany_total = 0;
									_which = 1;
								}else if(previousCmOrderNoValue===row.cm_order_no && previousJanValue===row.JAN && row.hattyuu_status_now==='未発注'){
									prev_hattyuu_howmany_total = prev_hattyuu_howmany_total + prev_hattyuu_howmany;
									amount_diff = row_amount - prev_hattyuu_howmany_total - hattyuu_val;
									_which = 2;

									if(amount_diff!==0){ // 数量　満になっていない場合
										if(previousStatus!=='完了'){
											diff_total = diff_total - (row_amount-prev_hattyuu_howmany_total);
											_which = 20;
										}else{
											//diff_total = diff_total + amount_diff;
											hattyuu_val_total = hattyuu_val_total - hattyuu_val;
											_which = 25;
										}

									}else if(amount_diff===0){ // このKEY 数量　満になっている場合
										//diff_total = diff_total - prev_hattyuu_howmany_total; // 10128509 様子見
										if(previousStatus!=='完了'){
											diff_total = diff_total - hattyuu_val;
											_which = 21;
										}else{
											hattyuu_val_total = hattyuu_val_total - hattyuu_val;
											_which = 26;
										}

									}

									
								}else{
									amount_diff = row_amount - hattyuu_val;
									prev_hattyuu_howmany_total = 0;
									_which = 3;

									//if(amount_diff!==0 && diff_total===0 && index===0){ // １行目受注数 2 , 発注 1、 2行目で揃っている場合
									//	diff_total = diff_total - amount_diff;
									//	_which = 22;
									//}

								}
								
								
							}else if(this.props.data.table_tonya_label!=='欠品'){ // JAN と 管理番号同じ
								//console.log(row.cm_order_no);
								//console.log(previousCmOrderNoValue);
								//console.log(previousJanValue);
								//console.log(row.JAN);
								
								prev_hattyuu_howmany_total = prev_hattyuu_howmany_total + prev_hattyuu_howmany;
								amount_diff = row_amount - prev_hattyuu_howmany_total;
								_which = 4;
							}else{
								//console.log('問屋フィルターで欠品した時のみっここ');
								amount_diff = addCmListFunction.getAmountdiff(row.amount_fix, row, this.state.dataFixIdArray, this.props.data.cm_datas, this.props.data.table_tonya_label );
								if(this.props.data.table_tonya_label==='欠品'){
									row_amount_total = row_amount_total + row.amount_fix;
								}
								_which = 5;
							}


              let hikiate_diff = hattyuu_val-row.hikiate_howmany;

							diff_total = diff_total+amount_diff;



							/* 確認用 */
							let _check_array = ['10127906'];
							//if(previousCmOrderNoValue===row.cm_order_no && previousJanValue===row.JAN){
								if(_check_array.includes(row.cm_order_no)){
								//if(_which===21){
									//console.log('row_amount_total _which:'+String(_which)+'　'+String(row_amount_total-row.amount_fix)+' '+String(row.amount_fix)+' '+row.order_key+' '+_str);
									console.log('チェック _which:'+String(_which)+' KEY:'+row.order_key+' amount_diff:'+String(amount_diff)+' row_amount:'+String(row_amount) +' prev_hattyuu_howmany:'+String(prev_hattyuu_howmany)+' prev_hattyuu_howmany_total:'+String(prev_hattyuu_howmany_total) +' diff_total:'+String(diff_total)+' row_amount_total:'+String(row_amount_total)+' hattyuu_val_total:'+String(hattyuu_val_total)+' hattyuu_val:'+String(hattyuu_val) );
									console.dir(row);
								}




							let jan_1 = row.JAN.slice( 0, 6 );
							let jan_2 = row.JAN.slice( 6, 13 );

							let item_name_str = '';
							//console.log(this.state.item_name_full_index);
							if(index!==this.state.item_name_full_index && row.cm_item_name!==null){
								item_name_str = row.cm_item_name.substr(0, 12)+'...';
							}else{
								item_name_str = row.cm_item_name;
							}

							let comment_str = '';
							if(index!==this.state.comment_full_index){
								//console.log(row.comment);
								if(row.comment!==null){
									comment_str = row.comment.substr(0,12)+'...';
								}
							}else{
								comment_str = row.comment;
							}

							let customer_address = '';
							if(row.cm_customer_address!==null){
								customer_address = row.cm_customer_address.substr(0, 12)+'...';
							}else{
								customer_address = '';
							}

							//console.dir(this.props.data);
							if(this.props.data.isit_hattyuu_board===true && this.props.data.table_tonya_label!=='all' && this.props.data.formData!==undefined){
								isit_checkbox_show = true;
								if(this.props.data.formData.includes(row.id)){
									checkbox_boolean = true;
								}else{
									checkbox_boolean = false;
								}

								//console.dir(this.props.data.show_syukka_data_id_arrays);
								if(this.props.data.show_syukka_data_id_arrays.includes(row.id)){
									isit_show_hikiate_howmany = true;
								}
							}

							try{
								if(this.props.data.show_cut_hattyuu_box===true && this.props.data.formDataCutHattyuu.includes(row.id)){
									checkbox_boolean_cut_hattyuu = true;
								}else{
									checkbox_boolean_cut_hattyuu = false;
								}
							}catch(error){
								//this.props.data.formDataCutHattyuu = [];
							}



							if(isit_show_hikiate_howmany){
								hikiate_input_class = 'form-control form-control-sm border border-warning text-center';
							}else{
								hikiate_input_class = 'form-control form-control-sm border border-warning text-center bg-input-lock';
							}

							let hattyuu_status_now_str = '';
							if((row.cm_item_name.indexOf('予約注文___') !== -1 || row.cm_item_name.indexOf('予約注文欠品___') !== -1) && row.hattyuu_status_now==='発注済'){
								hattyuu_status_now_str = '予約'+row.hattyuu_status_now;
							}else{
								hattyuu_status_now_str = row.hattyuu_status_now;
							}


							// 単品特価
							let show_tonya_item_url = null;
							if(row.hattyuu_status_now==='未発注' && row.which_tonya.indexOf('単品特価') !== -1){
								show_tonya_item_url = row.item_url;
							}

							// 代引き
							let show_cash_on_delivery = null;
							//if(row.delivery==='ヤマト コレクト（代引）'){
							//	show_cash_on_delivery = true;
							//}
							if(row.payment==='代金引換'){
								show_cash_on_delivery = true;
							}


          	  return(
								<tr key={'tr2_'+String(row.id)} className={tr_class_name} onClick={event=>trIndexClick(event)} data-row-id={row.id}>
									<td
										className='table-col bg-light nowrap'
									>
										{this.props.data.show_cut_hattyuu_box ? <>
											<Form.Check
												className={this.props.data.click_cut_hattyuu_box===false ? "index-checkbox mx-1" : "index-checkbox mx-1 clicked-cut-hattyuu"}
												data-check-id={row.id}
												data-index={index}
												onClick={event=>checkboxClickCutHattyuu(event)}
												checked={checkbox_boolean_cut_hattyuu}
												name = 'index_checkbox_cut_hattyuu'
											/>
										</> : <></>}


										{count}
										{/* <span onClick={event=>trClick(event)}>{sankaku_mark}</span> */}

										{ isit_checkbox_show ?
												<Form.Check
													className="index-checkbox"
													data-check-id={row.id}
													data-index={index}
													onMouseOver={event=>checkboxMouseOver(event)}
													onMouseOut={event=>checkboxMouseOut(event)}
													onClick={event=>checkboxClick(event)}
													checked={checkbox_boolean}
													name = 'index_checkbox'
												/>
										: <></>}
									</td>

									<td className="table-col nowrap">{hattyuu_status_now_str}</td>
									<td className="table-col nowrap">
										<span className="click-pointer-elem" data-db-jan={row.JAN} data-db-cm-order-no={row.cm_order_no} onClick={this.openOrderHistoryModal}>{row.cm_order_no}</span>
									</td>
									<td className="table-col nowrap">{row.meisai_gyou}</td>
									<td className="table-col bg-light nowrap">{row.order_key}</td>
									<td className="table-col nowrap">{row.amount_fix}</td> {/* 何個発注-->受注数 */}

									{/* <td className="table-col nowrap" data-db-id={row.id} onClick={this.openOrderHistoryModal}>{row.JAN}</td> */} {/* JAN */}
									<td className="table-col bg-light nowrap" >
										<span className="click-pointer-elem" data-db-id={row.id} data-db-jan={row.JAN} onClick={this.openJanInfo}>{jan_1}</span>
										<span className="click-pointer-elem" data-db-id={row.id} data-db-jan={row.JAN} onClick={this.openJanNextInfo}>{jan_2}</span>
										{show_tonya_item_url!==null ? 
											<a className="tonya-item-link" target="_blank" href={row.item_url}>
												<i className="bi bi-box-arrow-up-right" data-icon="tonya-item-link"></i>
											</a> : <></>
										}
									</td>

									<td className="table-col bg-light nowrap">{row.item_type}</td>

									<td className="table-col nowrap ">{/* 発注No */}
										<input
											type="text"
											data-input-id={row.id}
											data-index={index}
											name="hattyuu_no"
											className={hattyuu_no_input_class}
											style={input_style_obj}
											value={map_array[index].hattyuu_no}
											onChange={event=>handleInputChange(event)}
										/>
									</td>

									<td className="table-col nowrap"> {/* 発注日 */}
										{hattyuu_date}
									</td>

									<td className={"table-col nowrap input-hattyuu-howmany"}> {/* 発注数 */}
										<input
											type="text"
											data-input-id={row.id}
											data-index={index}
											name="hattyuu_howmany"
											className={hattyuu_input_calss_str}
											value={hattyuu_val}
											onChange={event=>handleInputChange(event)}
											disabled={this.state.hattyuu_input_lock ? true : false}
										/>
										{ hattyuu_status_now_str!=='未発注' ? 
											<>
												{hattyuu_status_now_str!=='発注済' && hattyuu_status_now_str!=='予約発注済' ? 
													<><div className="cell-finish-mark">完</div></> : 
													<><i className="bi bi-check-lg input-hattyuu-zumi-check-mark"></i></>}
											</> 
											: 
											<div className="for_mihattyuu_hattyuuzumi_label">
												{for_mihattyuu_hattyuuzumi_label}
											</div>  }
										{ keppin ? <div className="keppinn-icon">欠</div> : <></>}
									</td>

									<td
										className="table-col nowrap"
										//id={"diff_"+String(index)}
									> {/* 🦏 受注数-発注数 */}
										{amount_diff}
										{prev_hattyuu_zumi!=='' ? <>(済{prev_hattyuu_zumi})</> :<></>}
										　({row_amount_total - hattyuu_val_total - diff_total}) {/* DEV */}
									</td>

									<td className="table-col nowrap">{/* 引き当て数 */}
										{hattyuu_status_now_str!=='未発注' ?
											<input
												type="text"
												data-input-id={row.id}
												data-index={index}
												name="hikiate_howmany"
												className={hikiate_input_class}
												//value={this.props.data.hikiate_howmany}
												value={isit_show_hikiate_howmany ? row.hikiate_howmany : ''}
												onChange={event=>handleInputChange(event)}
											/> 
										: <></>}
									</td>

									<td
										className="table-col nowrap"
									> {/* 🦏  発注-引あたり */}
										{isit_show_hikiate_howmany ? <>{hikiate_diff}</> : ''}
										{prev_hikiate_howmany!=='' ? <>(済{prev_hikiate_howmany})</> :<></>}
									</td>

									<td className="table-col nowrap "> {/* 出荷日カレンダー */}
										{isit_show_hikiate_howmany ? 
											<input 
												size="sm"
												type="date"
												name="from"
												className={hikiate_input_class}
												//id={"tonya_syukka_date_"+String(row.id)}
												data-index={index}
												value={row.when_syukka}
												data-input-id={row.id}
												onChange={event=>handleInputChange(event)}
											/>
										:<></>}
									</td>
									<td className="table-col nowrap">{row.cm_phase}</td>
									<td className="table-col nowrap">{row.which_tonya}</td>

									<td className="table-col nowrap">{row_amount}</td>
									<td className="table-col nowrap click-pointer-elem" data-index={index}  onClick={this.changeItemNameFull}>
										{item_name_str}
									</td>
									<td className="table-col nowrap">{row.color_type}</td>
									<td className="table-col nowrap">{row.size_type}</td>
									<td className="table-col nowrap">{row.cm_unit_price}</td>
									<td className="table-col nowrap">{tonya_price}</td>
									<td className="table-col nowrap">{row.maniau}</td>
									<td className="table-col nowrap">{row.arrival_aichi!==null ? row.arrival_aichi.replace('2023-','').replace('T',' ').slice( 0, -3 ) : ''}</td>
									<td className="table-col nowrap">{row.deli_limit_date!==null ? row.deli_limit_date.replace('2023-','').replace('T',' ').slice( 0, -3 ) : ''}</td>
									<td className="table-col nowrap">{row.order_date !==null ? row.order_date.replace('2023-','').replace('T',' ').slice( 0, -3 ) : ''}</td>
									<td className="table-col nowrap">{row.store_name}</td>
									<td className="table-col nowrap">{row.store_order_no}</td>
									<td className="table-col nowrap">{row.item_code}</td>
									<td className="table-col nowrap">{row.cm_ship_name}</td>
									<td className="table-col nowrap">{row.cm_customer_post}</td>
									<td className="table-col nowrap">
										{show_cash_on_delivery ? <span className="text-danger">(代)</span> : <></>}
										{customer_address}
									</td>
									<td className="table-col nowrap click-pointer-elem" data-index={index} onClick={this.changeCommentFull}>{comment_str}</td>
									<td className="table-col nowrap">{row.tonya_latest_inventory}</td>
									<td className="table-col nowrap">{row.created_at!==null ? row.created_at.replace('2023-','').replace('T',' ').slice( 0, -3 ) : ''}</td>

								</tr>

          	  )
          	})}

					</tbody>
					<tfoot>
  				  <tr>
  				    <td>
								{ isit_checkbox_show ?
									<>
							  		<Button variant="outline-primary" id="checkbox-submit" size="sm" onClick={event=>submitCheckbox(event)}>
											確認
										</Button>
									</>
									: <></>}
								{ this.state.mouseClick ? <>
									<div onClick={event=>resetCheckBoxFunction(event)} className="click-pointer-elem checkbox-function-none">チェックボックス機能無効にする</div>
								</> : <></>}
							
							</td>

							<td></td><td></td><td></td><td></td>
							{/*<td className="text-center">{this.props.data.howmany_order}</td>  */}
							<td  className="text-center">{row_amount_total}</td>
							<td></td><td></td><td></td><td></td>
							<td className="text-center">
								{hattyuu_val_total}
								{prev_hattyuu_zumi_total!==0 ? <>(内発注済:{prev_hattyuu_zumi_total})</> : <></>}
								{/*
								{diff_counter_label!=='' ? <><br /><div className="nowrap diff-counter-label">（{diff_counter_label}:{this.props.data.diff_counter}）</div></> : <></>}
								*/}
							</td>
							<td className="text-center"> {/* 調整値 row_amount_total - hattyuu_val_total - diff_total */}
								{row_amount_total - hattyuu_val_total - diff_total < 0 ? 
									<>{diff_total + (row_amount_total - hattyuu_val_total - diff_total)}</> : 
									<>{diff_total}</>
								}
								</td>
							<td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
  				  </tr>
  				</tfoot>

				</table>

      
        {/* <i className="bi-card-list px-1 mx-1 bg-dark text-white"  onClick={this.openOrderHistoryModal}></i> */}

				{/*
        <Modal show={this.state.isOrderHistoryOpen} onHide={this.closeOrderHistoryModal} className="modal-dialog modal-lg">
          <Modal.Header closeButton>
            <Modal.Title>発注履歴</Modal.Title>
          </Modal.Header>
          <Modal.Body>
					<div className="container">
					  <Row>
							<Col>JAN：</Col>
							<Col>管理番号：</Col>
						</Row>
					</div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeOrderHistoryModal}>Close</Button>
          </Modal.Footer>
        </Modal>
				*/}

				{this.state.isOrderHistoryOpen ? 
					<>
						<div className="jan-info-content">
							<div>履発注歴: <br/>管理番号:{this.state.history_cm_order_no}　JAN:{this.state.history_jan}</div>
							{this.state.history_array.length===0 ? <>なし</> : 
								<>
									<table className="show-hatyuu-history">
										<tr className="text-center">
											<th>KEY</th><th>ファイル名</th><th>数量</th><th>発注日</th><th>担当</th>
										</tr>

										{this.state.history_array.map((data, index)=>{
											let day = addCmListFunction.convertDate('', data.created_at)
        							return(
												<tr key={"hh_"+String(index)}>
													<td>{data.hattyuu_key}</td><td>{data.which_tonya}</td><td className="text-center">{data.amount}</td><td>{day}</td><td>{data.who}</td>
												</tr>
											)
										})}
									</table>
								</> 
							}

							<div className="jan-info-close-button" onClick={this.closeOrderHistoryModal}><i className="bi bi-x-circle"></i></div>
						</div>
					</>
					:
					<></>
				}

        

				{/* </Form> */}


				{this.state.show_hattyuu_check ?
					<div className="hattyuu-check-board">
						{/* データを整える */}
						{this.props.data.dataArray.map((data, index)=>{
							if(this.props.data.formData.includes(data.id)){
								var _hikiate_how = data.hikiate_howmany;
								if(_hikiate_how===''){
									_hikiate_how = 0;
								}

								let jan_obj = {};
								if(hattyuu_jan_array.length===0){
									jan_obj[data.JAN] = data.hikiate_howmany;
									jan_obj['item_type'] = data.item_type;
									jan_obj['key'] = data.order_key;
									jan_obj['JAN'] = data.JAN;
									jan_obj['item_name'] = data.tonya_item_name;
									jan_obj['color'] = data.color_type;
									jan_obj['size'] = data.size_type;
									jan_obj['cm_order_no'] = data.cm_order_no;
									jan_obj['when_syukka'] = data.when_syukka;
									jan_obj['hattyuu_no'] = data.hattyuu_no;
									jan_obj['id'] = data.id;
									hattyuu_jan_array.push( jan_obj );
								}else{
									let isit_in_array = false;
									let which_i = 0;
									for (let i = 0; i < hattyuu_jan_array.length; i++) {
										if(hattyuu_jan_array[i].hasOwnProperty(data.JAN)){
											//hattyuu_jan_array[i][data.JAN] = hattyuu_jan_array[i][data.JAN] +  _hikiate_how;
											isit_in_array = true;
											which_i = i;
											break;
										}else{
											isit_in_array = false;
											//jan_obj[data.JAN] = _hikiate_how;
											//jan_obj['item_type'] = data.item_type;
											//jan_obj['key'] = data.order_key;
											//hattyuu_jan_array.push( jan_obj );
											//break;
										}
									}

									
									// ZETT,など　JAN で数を丸めない問屋
									let now_select_tonya_id = addCmListFunction.convertTonyaNameToId(this.props.data);
									//let write_key_tonya_id_array = [12,13,14,15,20, 31,  34, 42, 53, 54, 55, 101, 102, 103, 111, 105, 106]; //KEY記載する問屋リスト, JANをまとめない, BoardFunction.js内にも
									let write_key_tonya_id_array = settings.NO_COUNT_SAME_JAN_TONYA_IDs;
									//console.log('now_select_tonya_id '+String(now_select_tonya_id));
									//console.dir(write_key_tonya_id_array);
									if (write_key_tonya_id_array.includes(now_select_tonya_id)) {
										isit_in_array = false;
									}


									if(isit_in_array===true){
										hattyuu_jan_array[which_i][data.JAN] = hattyuu_jan_array[which_i][data.JAN] +  _hikiate_how;
									}else{
										jan_obj[data.JAN] = _hikiate_how;
										jan_obj['item_type'] = data.item_type;
										jan_obj['key'] = data.order_key;
										jan_obj['JAN'] = data.JAN;
										jan_obj['item_name'] = data.tonya_item_name;
										jan_obj['color'] = data.color_type;
										jan_obj['size'] = data.size_type;
										jan_obj['cm_order_no'] = data.cm_order_no;
										jan_obj['when_syukka'] = data.when_syukka;
										jan_obj['hattyuu_no'] = data.hattyuu_no;
										jan_obj['id'] = data.id;
										hattyuu_jan_array.push( jan_obj );
									}
								}
							}

							//console.dir(data);
						})}

						<table  className="form-control-select-mini mb-4 text-center" >
							<tr>
								<td>問屋名</td>
								<td>{this.props.data.table_tonya_label}</td>
							</tr>
							<tr>
								<td>チェック中のKey数</td>
								<td>{this.props.data.formData.length}</td>
							</tr>
							<tr>
								<td>チェック分のJAN数</td>
								<td>{hattyuu_jan_array.length}</td>
							</tr>
						</table>

						<Form onSubmit={handleSubmitHikiateOkButton} className="form-control-select">
							<table className="hattyuu_check_pop_table">

                {(() => {
									console.dir(hattyuu_jan_array);
									let th_elems = addCmListFunction.getSyukkaCheckBoardTh(this.props.data.table_tonya_label, this.props.data.tonya_datas);
                  return(
                    <tr>
											<th>No.</th>
											{parse(th_elems)}
											<th>引当たり数</th>
											<th>出荷日</th>
                    </tr>
                  )
                })()}


								{hattyuu_jan_array.map((data_obj, index)=>{
									//console.dir(data_obj);

									let count = 0;
									let _jan = '';
									let _val = 0;
									let _item_type = '';
									let _key = '';
									let item_name = '';
									let color = '';
									let size = '';
									let _cm = '';
									let _hattyuu_no = '';
									let _when_syukka = '';
									let _id = '';
									for (const [key, value] of Object.entries(data_obj)) {
										if(count===0){
											_jan = key;
											_val = value;
										}else if(key==='item_type'){
											_item_type = value;
										}else if(key==='key'){
											_key = value;
										}else if(key==='JAN'){
											_jan = value;
										}else if(key==='item_name'){
											item_name = value;
										}else if(key==='color'){
											color = value;
										}else if(key==='size'){
											size = value;
										}else if(key==='cm_order_no'){
											_cm = value;
										}else if(key==='when_syukka'){
											_when_syukka = value;
										}else if(key==='hattyuu_no'){
											_hattyuu_no = value;
										}else if(key==='id'){
											_id = value;
										}
										count++;
									}

									let td_elems = addCmListFunction.getSyukkaCheckBoardtype(this.props.data.table_tonya_label, this.props.data.tonya_datas, _jan, _item_type, _key, item_name, color, size, _cm, _hattyuu_no);

									return(
										<tr key={"hattyuu_check_"+String(index)}>
											<td>{index+1}</td>
											{/*
											<td>{_jan}</td>
											<td>{_item_type}</td>
											*/}
											{parse(td_elems)}
											<td>
												<input
													type="text"
													data-jan={_jan}
													data-index={index}
													data-input-id={_id}
													name="hikiate_howmany_2"
													className="form-control form-control-sm border border-warning text-center width-3rem d-inline"
													//value={this.props.data.hikiate_howmany}
													value={_val}
													onChange={event=>handleInputChange(event)}
												/>
											</td>
											<td className={index===0 ? "position-relative" : ""}>
												<InputGroup size="sm" className="border border-warning">
              					  <Form.Control
														type="date"
														name="from_2"
														placeholder=""
														aria-describedby="from_2"
														//id={"tonya_syukka_date_"+String(row.id)}
														data-jan={_jan}
														data-index={index}
														data-input-id={_id}
														value={_when_syukka}
														onChange={event=>handleInputChange(event)}
													/>
              					</InputGroup> 

												{index===0 ? 
													<div className="lock-icon-child syukka_date_paste click-pointer-elem " onClick={this.pasteSyukkaDate}><i className="bi bi-arrow-bar-down"></i></div>
												 : <></>
												}
												
											</td>

										</tr>
									)

								})}
							</table>

							<Button variant="primary" id="hattyuu-check-board-submit" size="sm" type="submit" className="mt-2">
								OK
							</Button>
							<div className="jan-info-close-button" onClick={this.closeSubmitCheckbox_2}><i className="bi bi-x-circle"></i></div>

						</Form>

					</div> :
					<></>
				}


				{this.state.toast_array.length>0 ? 
					<div className="toast_area">
						{this.state.toast_array.map((row, index)=>{
						
							return(
								<div className="toast_child" key={'toast_'+row.id}>
									{row.text}
									<div className="toast-close-button">
										<i className="bi bi-x-circle" id={"toast_"+String(row.id)} onClick={event => closeToastChild(event)}></i>
									</div>
								</div>
							)
							
						})}
					</div> 
					: <></>
				}




				{this.state.click_jan_info ?
					<div className="jan-info-content">
						<div>過去履発注歴: {this.state.jan_info_jan}</div>
						{this.state.jan_info_array.length===0 ? <>なし</> : <></> }
						{this.state.jan_info_array.map((data, index)=>{
							let day = addCmListFunction.convertDate('jan-info', data.created_at)
        			return(
								<div key={"jan_info_"+String(index)}>{data.which_tonya+' ('+day+')'}</div>

							)
						})}
						<div className="small">(最大 5件表示)</div>
					<div className="jan-info-close-button" onClick={this.closeJanInfo}><i className="bi bi-x-circle"></i></div>
				</div> : <></>}


				{this.state.click_jan_next ?
					<div className="jan-info-content jan-next-info-content">
						<div className="mb-2">次の引き当て予定: {this.state.jan_next_jan}</div>
						{this.state.jan_next_obj.which_tonya==='欠品' ?
							<>
								<div>次なし、欠品予定</div>
								<div className="jan-info-close-button" onClick={this.closeJanNextInfo}><i className="bi bi-x-circle"></i></div>
							</> :
							<>
								<div>問屋商品名:{this.state.jan_next_obj.tonya_item_name}</div>
								<div>問屋名：{this.state.jan_next_obj.which_tonya}</div>
								<div>在庫数(DB)：{this.state.jan_next_obj.stock}</div>
								<div className="jan-info-close-button" onClick={this.closeJanNextInfo}><i className="bi bi-x-circle"></i></div>
							</> }

				</div> : <></>}


				<div className="container qa-footer">
					<div className="row">
						<div className="col-sm">
							memo:
							<ul>
								<li>発注No. ↓ は、最後に発注No.入力したより下の行の発注No.を変更します.</li>
								<li>発注No.枝番は、予約注文した分.</li>
								<li>発注除外チェックボックス、クリック後、3,4秒して反映されます.遅い場合は、他の場所をクリックしてみてください.</li>
								<li>検索(ブラウザ)は or 検索のみです...</li>
								<li>検索(サーバー)は、１キーワードの単品検索のみです...</li>
								<li>JAN 左側クリックで過去履歴確認できる</li>
								<li>JAN 右側クリックで次の引き当て問屋さん確認できる</li>
								<li>ページ離脱時のポップでキャンセルして滞在した場合でも、サーバー的には離脱として記録されます.</li>
								<li>便利なChrome拡張機能 <a href="https://chrome.google.com/webstore/detail/columncopy/lapbbfoohlcmlbdaakldmmallcbcbpjb?hl=ja" target="_blank">ブラウザ上の列のみ、表のみをコピーできるツール（無料）</a></li>

								<li>未完了分、キャンセルフェーズ以外の管理番号分を表示しています。それ以外は、order_data.xlsx もしくは 検索(サーバー) をご利用願います。</li>

							</ul>
						</div>
						<div className="col-sm">
							Q&A
							<ul>
								<li className="my-1">Q：下段の表が何も表示されない<br />A：検索バーのクリアボタンを押してみてください.</li>
								<li className="my-1">Q：問屋番号クリックしても下段表、表示なし<br />A：検索キークリアして、再度番号クリックしてみてください.</li>
								<li className="my-1">Q：出荷確認、１問屋複数回チェックする場合は？<br />A：対象問屋のチェックボックスのチェックを外して、もう一回チェックお願いします。</li>
								<li className="my-1">Q：出荷確認、引き当たり0、出荷日入力あった場合は？<br />A：出荷日入力あっても、引き当たり数1以上なければ、その行の日付無視されます.</li>
								<li className="my-1"></li>
								<li className="my-1"></li>
							</ul>
						</div>
					</div>
				</div>

				<div className="container qa-footer my-2">
					<div className="row">
						<div className="col-sm">
							<div className="my-2">在庫データの取り込みが始まるが、作業を継続したい場合</div>
							<ul>
								<li>画面右上の歯車マークをクリックして、在庫取込モードを手動にする</li>
								<li>自動取り込みはストップされます</li>
								<li>キリのいいところで　ボタン：在庫更新する　をクリック</li>
								<li>15分毎のチェッカーにより、取込を開始します</li>
								<li>終わればチャットワークに通知いきます</li>
								<li>必要に応じて、モードは自動に切り替えてください.</li>
							</ul>
						</div>

						<div className="col-sm">
							<div className="my-2">参考手順</div>
							<ol>
								<li>Order_data.xlsxダウンロード、欠品リスト確認</li>
								<li>管理的変更で完全欠品分を完了にする</li>
								<li>差し戻し分確認、必要あれば発注依頼の作成で対象分修正</li>
								<li>ページ再読み込みして、発注</li>
							</ol>
						</div>
					</div>
				</div>


				<div className="container qa-footer my-2">
					<div className="row">
						<div className="col-sm">
							<div className="text-danger">免責</div>
							<ul>
								<li>完了以外を表示しています。完了分確認の場合は、検索：サーバーにてお願いします。</li>
							</ul>
						</div>

						<div className="col-sm">
						</div>
					</div>
				</div>


				{/*
				<div className="go-top-button">
					<div className="click-pointer-elem"><i class="bi bi-arrow-up-circle" onClick={this.goTop}></i></div>
				</div>
				*/}

				{this.props.data.tonya_no_click ? <div className="which_tonya_checkking_label">確認中：{this.props.data.table_tonya_label}</div> : <></>}

      </main>
    );
  }
}
